// extracted by mini-css-extract-plugin
export default {"RootLayout":"layout_RootLayout__7OQcE","RootLayoutInner":"layout_RootLayoutInner__4bTrb"};